import React from 'react';

import { ELMA365VersionProblem, ELMA365VersionStage, ELMA365VersionStatus } from '../../../../../../gamma-api';
import StatusInfo from '../../../../../components/common/StatusInfo';
import { StatusInfoState, StatusInfoTheme } from '../../../../../components/common/StatusInfo/types';
import { getTranslateFunc } from '../../../../../utils/stringUtil';

import './index.less';

import { DEFAULT_ITEM, MAIN_CLASS_NAME } from './const';

export interface IVersionStatusProps {
  status?: ELMA365VersionStatus;
  stage?: ELMA365VersionStage;
  problem?: ELMA365VersionProblem | null;
  onRestart?: () => void;
}

const VersionStatus: React.FC<IVersionStatusProps> = ({ status, stage, problem, onRestart }) => {
  const translate = getTranslateFunc('Toolkits: ELMA365: Version:');

  const getCurrent = (): number => {
    if (stage === ELMA365VersionStage.Namespaces) {
      return 1;
    }

    if (stage === ELMA365VersionStage.Applications) {
      return 2;
    }

    if (stage === ELMA365VersionStage.Processes) {
      return 3;
    }

    if (stage === ELMA365VersionStage.Tools) {
      return 4;
    }

    return 0;
  };

  const getStatus = (): StatusInfoState => {
    if (status === ELMA365VersionStatus.Processing) {
      return StatusInfoState.Process;
    }

    if (status === ELMA365VersionStatus.Problem) {
      return StatusInfoState.Error;
    }

    if (status === ELMA365VersionStatus.Ready) {
      return StatusInfoState.Finish;
    }

    return StatusInfoState.Pause;
  };

  const items = [
    { ...DEFAULT_ITEM, title: translate('Connector') },
    { ...DEFAULT_ITEM, title: translate('Namespaces') },
    { ...DEFAULT_ITEM, title: translate('Applications') },
    { ...DEFAULT_ITEM, title: translate('Processes') },
    { ...DEFAULT_ITEM, title: translate('Tools') },
  ];

  const itemIndex = getCurrent();
  const itemStatus = getStatus();

  if (itemStatus === StatusInfoState.Error) {
    const item = items[itemIndex];
    item.subtitle = translate('Problem: Subtitle');
    item.description = translate('Problem: Description');
    item.problem = problem;
    item.modal = true;
  }

  return (
    <StatusInfo.Steps
      className={MAIN_CLASS_NAME}
      current={itemIndex}
      direction="horizontal"
      items={items}
      rolling={false}
      status={itemStatus}
      style="compact"
      theme={StatusInfoTheme.Blue}
      onRestart={onRestart}
    />
  );
};

export default VersionStatus;
